import { SVGProps } from 'react';

export const InfoRoundedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 15H7V13H9V10H8V8H10C10.552 8 11 8.448 11 9V13H13V15ZM10 4.75C10.69 4.75 11.25 5.31 11.25 6C11.25 6.69 10.69 7.25 10 7.25C9.31 7.25 8.75 6.69 8.75 6C8.75 5.31 9.31 4.75 10 4.75ZM10 0C4.486 0 0 4.486 0 10C0 15.515 4.486 20 10 20C15.514 20 20 15.515 20 10C20 4.486 15.514 0 10 0Z"
      fill="currentColor"
    />
  </svg>
);
